import type { CSSProperties, ReactNode } from 'react';

export const PCard = ({
  children,
  style,
  onClick,
  interactive,
}: {
  children: ReactNode;
  style?: CSSProperties;
  onClick?: () => void;
  interactive?: boolean;
}) => (
  <div
    className={`p-card${interactive || onClick ? ' p-card--interactive' : ''}`}
    onClick={onClick}
    style={style}
  >
    {children}
  </div>
);
